import React, { Component } from 'react';
import { loguear, cerrarSesion, getListadoCursos, recuperarLogueo } from '../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// import _ from 'lodash';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

import Encabezado from './encabezado';

class Menu extends Component {
  constructor(props){
    super(props);

    this.state = {
      searchQuery: "",
      redirect: null
    }

    this.updateQuery = this.updateQuery.bind(this);
    this.onQueryChange = this.onQueryChange.bind(this);
  }

  componentDidMount(){
    if(this.props.usuario===null || this.props.usuario===undefined){
      if(localStorage.getItem("session_token")!=null){
        this.props.recuperarLogueo(localStorage.getItem("session_token"));
      }
    }
  }

//TODO: ver que redirija usando el enlace
  updateQuery(evt){
    evt.preventDefault()
    let query = this.state.searchQuery;
    this.props.getListadoCursos(query);
  }

  onQueryChange(evt){
    this.setState({
      searchQuery: evt.target.value
    });
  }

  isLogued(){
    return this.props.usuario!==undefined &&
    this.props.usuario!==null &&
    this.props.usuario.session_token!==undefined &&
    this.props.usuario.session_token!==null;
  }

  render(){
    return (
      <div>
        <section id="menu">
          <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
            <a className="navbar-brand">CEIS</a>
            <button className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <Link to="/cursos/1" className="nav-link">Ver Cursos</Link>
                </li>
                <li className="nav-item">
                  <Link to="/mis-certificados" className="nav-link">Consultar Certificados</Link>
                </li>
                <li className="nav-item">
                  {this.isLogued() ?
                    (<Link to={`/mis-cursos`} className="nav-link">Mis Cursos</Link>) :
                    ""}
                </li>
                {/* <li className="nav-item">
                  {(this.props.carrito!==undefined && this.props.carrito!==null && _.size(this.props.carrito)>0) ?
                    (
                      <Link to="/carrito" className="nav-link carrito-btn">
                        Carrito <span className="badge badge-pill badge-info">{_.size(this.props.carrito)}</span>
                      </Link>
                    ) :
                    ""}
                </li> */}
              </ul>
              <div className="dropdown">
                <button className="btn btn-secondary dropdown-toggle"
                  type="button" id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i className="fas fa-user" /> {this.isLogued() ? this.props.usuario.nombres : "Usuario"}
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  {this.isLogued() ?
                    (<Link to='/estudiante' className="dropdown-item">Editar Datos</Link>) :
                    (<Link to="/login" className="dropdown-item">Iniciar Sesión</Link>)}


                  {this.isLogued() ?
                    (<div onClick={this.props.cerrarSesion} >
                      <Link to="/" className="dropdown-item">Cerrar Sesión</Link>
                    </div>) :
                    (<Link to="/registro" className="dropdown-item">Registrarse</Link>)}



                </div>
              </div>
              <form
                className="form-inline my-2 my-lg-0"
                onSubmit={this.updateQuery}>
                <div className="input-group">
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Buscar"
                    value={this.state.searchQuery}
                    onChange={this.onQueryChange}
                    aria-label="Search" />
                  <div className="input-group-append">
                    <button className="btn btn-light" type="submit">Buscar</button>
                  </div>
                </div>
              </form>

            </div>
          </nav>
          <NotificationContainer />
        </section>
        <Encabezado/>
      </div>
    );
  }
}

function mapStateToProps({ usuario, carrito }) {
  return { usuario, carrito };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loguear: loguear,
    cerrarSesion: cerrarSesion,
    getListadoCursos: getListadoCursos,
    recuperarLogueo: recuperarLogueo
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./src/containers/menu.js